import { render, staticRenderFns } from "./InvestmentSwitch.vue?vue&type=template&id=6e780908&scoped=true&"
import script from "./InvestmentSwitch.vue?vue&type=script&lang=js&"
export * from "./InvestmentSwitch.vue?vue&type=script&lang=js&"
import style0 from "./InvestmentSwitch.vue?vue&type=style&index=0&id=6e780908&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e780908",
  null
  
)

export default component.exports